/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowStepPanel.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Step
 *
 * PURPOSE:
 * Workflow Step Container
 *
 * RESPONSIBILITY:
 * • Display Step Header
 * • Display Add Button
 * • Display WorkflowStepTable
 *
 ******************************************************************************/

import React from "react";

import WorkflowStepTable
from "./WorkflowStepTable";

export default function WorkflowStepPanel({

    loading,

    workflowSteps,

    onAdd,

    onEdit,

    onDelete,

    onMoveUp,

    onMoveDown,

    onActivate,

    onDeactivate,

}) {

    return (

        <div className="card shadow-sm mt-3">

            <div className="card-header bg-white">

                <div
                    className="
                        d-flex
                        justify-content-between
                        align-items-center
                    "
                >

                    <h5 className="mb-0">

                        Workflow Steps

                    </h5>

                    <button
                        className="
                            btn
                            btn-primary
                        "
                        onClick={onAdd}
                    >

                        + Add Step

                    </button>

                </div>

            </div>

            <div className="card-body p-0">

                <WorkflowStepTable

                    loading={loading}

                    workflowSteps={workflowSteps}

                    onEdit={onEdit}

                    onDelete={onDelete}

                    onMoveUp={onMoveUp}

                    onMoveDown={onMoveDown}

                    onActivate={onActivate}

                    onDeactivate={onDeactivate}

                />

            </div>

        </div>

    );

}